import Vue from 'vue'
import VueRouter from 'vue-router'
import { showDeveloperAPI } from '@/helpers/sentinel'
import { beforeEachRouterEntry } from './before-each-router'

Vue.use(VueRouter)

let routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage/LoginPage.vue'),
  },
  {
    path: '/engagement',
    name: 'engagement',
    component: () => import('@/pages/Definitions/EngagementPage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/engagement-service',
    name: 'engagement-service',
    component: () => import('@/pages/Definitions/EngagementServicePage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/performance',
    name: 'performance',
    component: () => import('@/pages/Definitions/PerformancePage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/performance-service',
    name: 'performance-service',
    component: () => import('@/pages/Definitions/PerformanceServicePage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/notification',
    name: 'notification',
    component: () => import('@/pages/Definitions/NotificationPage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/management',
    name: 'management',
    component: () => import('@/pages/Definitions/ManagementPage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/management-service',
    name: 'management-service',
    component: () => import('@/pages/Definitions/ManagementServicePage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/growth',
    name: 'growth',
    component: () => import('@/pages/Definitions/GrowthPage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/growth-service',
    name: 'growth-service',
    component: () => import('@/pages/Definitions/GrowthServicePage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/api',
    name: 'api',
    component: () => import('@/pages/Definitions/APIPage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/api-data',
    name: 'apiData',
    component: () => import('@/pages/Definitions/APIDataPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/api-data-import',
    name: 'apiDataImport',
    component: () => import('@/pages/Definitions/APIDataImportPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/custom-surveys',
    name: 'customSurveys',
    component: () => import('@/pages/Definitions/CustomSurveysPage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/custom-surveys-service',
    name: 'custom-surveys-service',
    component: () => import('@/pages/Definitions/CustomSurveysServicePage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/scim',
    name: 'scim',
    component: () => import('@/pages/Definitions/ScimPage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/scim-idp',
    name: 'scim-idp',
    component: () => import('@/pages/Definitions/ScimIdpPage.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/mcp-service',
    name: 'mcp-service',
    component: () => import('@/pages/Definitions/McpServicePage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/lms',
    name: 'lms',
    component: () => import('@/pages/Definitions/LmsPage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/google-chat-events',
    name: 'google-chat-events',
    component: () => import('@/pages/Definitions/GoogleChatEventsPage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/rewards',
    name: 'rewards',
    component: () => import('@/pages/Definitions/RewardsPage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/trustline',
    name: 'trustline',
    component: () => import('@/pages/Definitions/TrustlinePage.vue'),
    meta: {
      requiresAuth: true,
      showDeveloperAPI,
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/pages/Home.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '*',
    redirect: '/login',
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
})

router.beforeEach(beforeEachRouterEntry)

export default router
